/**
 * Get the attribute value for the first element that matches
 * the specified name.
 */
export default function getMetaAttributeValue(name, attributeName) {
  const elements = [].slice.call(window.document.head.getElementsByTagName('meta'))
    .filter(element => element.getAttribute('name') === name || element.getAttribute('id') === name);
  return elements[0] ? elements[0].getAttribute(attributeName) : null;
}


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/get-meta-attribute-value.js